'use client';

import { useContext } from 'react';

import { ListingState } from '../listing.types';
import { ListingContext } from '../listing-context';

export const useListingContext = (): ListingState => {
  const context = useContext(ListingContext);

  if (!context) {
    throw new Error('useListingContext must be used within a ListingProvider');
  }

  return context;
};
